import { logger } from '~/utils/logger';

/**
 * Decodes a JWT token and returns its payload
 * @param token JWT token string
 * @returns decoded token payload or null if token is invalid
 */
export function decodeJWT<T = any>(token: string): T | null {
  try {
    // Check if token exists and has the correct format
    if (!token || typeof token !== 'string' || !token.includes('.')) {
      return null;
    }

    // Split the token into parts
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    // Get the payload (middle part)
    const payload = parts[1];

    // Base64 decode and parse JSON
    const decoded = JSON.parse(
      decodeURIComponent(
        atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      ),
    );

    return decoded as T;
  } catch (error) {
    logger.error('Error decoding JWT:', error);
    return null;
  }
}
